module.exports = __webpack_public_path__ + "img/th_bep.62030ef6.jpg";